import { Editor } from 'Pods/editor/editor';
import { HistoryEvent } from 'Pods/editor/history';

const handleEventStroke = () => {
    let inputsStrokeWidth = document.querySelectorAll(
        '.detail__editor__stroke input[type="range"], .detail__editor__stroke input[type="number"] ',
    );
    const noStrokesVisible = Editor.draw.find('g *').filter(element => element.attr('stroke-width') !== 0).length === 0;
    if (noStrokesVisible) {
        const editStrokeOption = document.getElementById('option_edit__stroke');
        editStrokeOption?.classList.add('hidden');
        return;
    }
    const originalWidth = Editor.draw
        .find('g *')
        .filter(element => element.attr('stroke-width') !== 0)[0]
        .attr('stroke-width');

    let inputInitialValue: HTMLInputElement | null = document.querySelector(
        '.detail__editor__stroke input[name="initial-width"]',
    );
    if (inputInitialValue) {
        inputInitialValue.value = originalWidth;
    }

    inputsStrokeWidth.forEach((element: HTMLInputElement) => {
        if (element.type == 'range') {
            element?.removeEventListener('input', changeWidthFromInput);
            element?.addEventListener('input', changeWidthFromInput);
        } else {
            element?.removeEventListener('change', changeWidthFromInput);
            element?.addEventListener('change', changeWidthFromInput);
            element.addEventListener('keypress', (e: KeyboardEvent) => {
                const inputValue = e.currentTarget as HTMLInputElement;
                const numberOfDigits = element.max.length;
                const regex = `/^[0-9]{0,${numberOfDigits}}$/`;
                if (
                    e.key != 'Enter' &&
                    !`${inputValue?.value}${e.key}`.match(/^[0-9]{0,2}$/) &&
                    window.getSelection()?.toString().length == 0 &&
                    numberOfDigits <= inputValue.value.length
                ) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
            });
        }

        element.value = originalWidth;
        element.setAttribute('max', (originalWidth * 2).toString());
    });
};

const changeWidthFromInput = function(e: Event) {
    e.stopPropagation();
    e.preventDefault();
    let element = e.currentTarget as HTMLInputElement;
    if (element.type == 'range') {
        strokeWidth(parseFloat(element.value), false, true);
    } else {
        if (+element.value > +element.max) {
            element.value = element.max;
        }
        if (+element.value < +element.min) {
            element.value = element.min;
        }
        strokeWidth(parseFloat(element.value), true, false);
    }
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
    // Editor.setAlertAndDownloadButton(false);
};

export const strokeWidth = function(
    value: number,
    modifyRange: boolean,
    modifyInput: boolean,
    fromHistory: boolean = false,
) {
    let strokes = Editor.draw.find('g *');

    if (strokes) {
        strokes.forEach(stroke => {
            if (stroke.node.style.strokeWidth !== '0') {
                stroke.node.style.strokeWidth = value.toString();
                stroke.stroke({ width: value });
            }
        });
    }
    if (modifyRange) {
        let rangeSizeElement = document.querySelector(
            '.detail__editor__stroke input[type="range"]',
        ) as HTMLInputElement;
        rangeSizeElement.value = value.toString();
    }
    if (modifyInput) {
        let inputSizeElement = document.querySelector(
            '.detail__editor__stroke input[type="number"]',
        ) as HTMLInputElement;
        inputSizeElement.value = value.toString();
    }
    let event: HistoryEvent = {
        type: 'strokeWidth',
        data: value,
    };

    if (Editor.history && !fromHistory) {
        Editor.history.push(event);
    }
    let saveIntoButtonElement = document.getElementById('save_into_active') as HTMLButtonElement;
    saveIntoButtonElement.disabled = false;
};

export const setInitialStrokeWith = () => {
    let inputInitialValue: string | null = (document.querySelector(
        '.detail__editor__stroke input[name="initial-width"]',
    ) as HTMLInputElement).value;

    if (inputInitialValue) {
        strokeWidth(Number(inputInitialValue), true, true, true);
    }
};

export const Stroke = {
    handleEventStroke,
};
